var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-hero" }, [
    _c(
      "div",
      {
        ref: "bg",
        staticClass: "background-image",
        style: "background-image: url('" + _vm.image + "')"
      },
      [
        _vm.video_id != null && _vm.video_id != ""
          ? [
              _vm.heroLoaded
                ? _c(
                    "div",
                    { ref: "videowrapper", staticClass: "video-wrapper" },
                    [
                      _c("vimeo-player", {
                        ref: "videoplayer",
                        attrs: {
                          "video-id": _vm.video_id,
                          "player-width": _vm.videoClientWidth,
                          "player-height": _vm.videoClientHeight,
                          autoplay: true,
                          loop: true,
                          options: _vm.vimeoOptions
                        },
                        on: { ready: _vm.videoPlayerReady }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "content d-flex justify-content-center align-content-start flex-column"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-11 offset-xl-1 text-center text-md-left"
              },
              [
                _c("h1", {
                  staticClass: "mb-40 text-white",
                  domProps: { innerHTML: _vm._s(_vm.title) }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-10 col-lg-8 offset-xl-1 text-center text-md-left"
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-xl-10" }, [
                    _c("p", {
                      staticClass: "mb-40 text-white font-weight-light",
                      domProps: { innerHTML: _vm._s(_vm.text) }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-accent align-self-start",
                        attrs: { href: _vm.href }
                      },
                      [
                        _vm._v(_vm._s(_vm.btn) + " "),
                        _c("span", {
                          staticClass: "arrow-right",
                          domProps: {
                            innerHTML: _vm._s(_vm.svg("arrow-right"))
                          }
                        })
                      ]
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }